import React, { useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import faqData from "../data/faq.json";
import "../styles/faq.css";

const FAQ = () => {
  const [activeId, setActiveId] = useState(null);

  const toggleFAQ = (id) => {
    setActiveId(activeId === id ? null : id);
  };

  return (
    <div className="faq-section">
      <div className="faq-header">
        <FontAwesomeIcon icon={faQuestionCircle} className="faq-header-icon" />
        <h2>Frequently Asked Questions</h2>
        <p>Quick answers to common questions</p>
      </div>

      <div className="faq-accordion">
        {faqData.map((item) => (
          <div 
            key={item.id} 
            className={`faq-item ${activeId === item.id ? 'active' : ''}`}
          >
            <button 
              className="faq-question"
              onClick={() => toggleFAQ(item.id)}
              aria-expanded={activeId === item.id}
            >
              <span>{item.question}</span>
              <FontAwesomeIcon 
                icon={faChevronDown} 
                className="faq-arrow" 
              />
            </button>
            <div className="faq-answer">
              <p>{item.answer}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQ;